export default __webpack_public_path__ + "static/media/Frame-5.28085e28.png";